/**
 * Created by Kamil on 24.05.2017.
 */

import React, {Component} from 'react';
import './CategoryFilter.css';
import FilterLink from "./FilterLink";
import axios from 'axios';

class CategoryFilter extends Component {
    constructor(props) {
        super(props);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.state = {filterData: []}
    }

    componentDidMount() {
        var _this = this;
        if (window.devMode) {
            _this.setState({
                filterData: window.filterDataMockup
            });

            for(var filter in window.filterDataMockup) {
                if (window.location.href.match(window.filterDataMockup[filter].slug))  {
                    this.handleFilterChange(window.filterDataMockup[filter].id);
                }
            }
        } else {
            var self = this;

            this.serverRequest =
                axios
                    .get('/wp-json/wp/v2/products_categories')
                    .then(function (result) {
                        _this.setState({
                            filterData: result.data
                        });

                        for(var filter in result.data) {
                            if (window.location.href.match(result.data[filter].slug))  {
                                self.handleFilterChange(result.data[filter].id);
                            }
                        }
                    });
        }
    }

    componentWillUnmount() {
        this.serverRequest.abort();
    }

    handleFilterChange(id) {
        this.props.changeFilter(id);
    }

    render() {
        var self = this;

        console.log(this.state.filterData);
        var listFilters = this.state.filterData.map(function (filter) {
            return (
                <FilterLink id={filter.id} changeFilter={self.handleFilterChange}
                            active={filter.id == self.props.activeFilterID ? true : false} name={filter.name}/>
            )
        });

        return (
            <div className="CategoryFilter">
                <div className="CategoryFilter-wrap">
                    <h2>Kategorie produktów:</h2>
                    {listFilters}
                    <FilterLink id={0} changeFilter={self.handleFilterChange}
                                active={0 == self.props.activeFilterID ? true : false} name='Wszystkie'/>
                </div>
            </div>
        );
    }
}

export default CategoryFilter;


// WEBPACK FOOTER //
// ./src/components/CategoryFilter.js